<template>
  <div id="exportDataPackage">
    <ots-main-title></ots-main-title>
    <ots-refer
      :selectList="selectList"
      :requestForm="requestForm"
    ></ots-refer>
    <div class="mainCon">
      <el-button round type="primary" plain @click="exportExamPackage">导出考试数据包</el-button>
      <el-button round type="primary" plain @click="export_QAN_Package">导出管理机注册二维码与序列号</el-button>
      <el-button round type="primary" plain @click="exportAuthCode">导出授权码</el-button>
    </div>


    <ots-custom-dialog :dialog.sync="downloadDialog" title="导出考试数据包" width="40%">
      <template v-slot:content> 
        <span style="margin-bottom: 8px; display: inline-block;">分块大小（大小 1MB ~ 10MB 之间）：</span>
        <el-input v-model.number="sizeByMB" placeholder="请输入分块大小"></el-input>
      </template>
      <template v-slot:footer>
        <div style="width: 100%; text-align: right;">
          <el-button round type="normal" @click="downloadDialog = false">关闭</el-button>
          <el-button round type="primary" @click="exportExamPackageSet" plain>确定</el-button>
        </div>
      </template>
    </ots-custom-dialog>

  </div>
</template>

<script>
import { getSelectPlanFn } from "@/http/modules/examSet/examBatch";
import { getCurrentSelectPlace } from "@/http/modules/examSet/planClass";
import { exportPlaceToPdfAPI, exportAuthCodeAPI } from "@/http/modules/computedRoomExam";
import { downloadPreGeneratedAnswerPaperAPI } from "@/http/modules/examSet/planClass";

export default {
  name: "exportDataPackage",
  data() {
    return {
      selectList: [
        {
          title: "批次名称",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: '考点名称',
          type: 'select',
          requestKey: 'placeId',
          label: 'name',
          value: 'id',
          data: [],
        },
        {
          title: '教室名称',
          type: 'select',
          requestKey: 'classId',
          label: 'name',
          value: 'id',
          data: [],
        },
      ],
      requestForm: {
        planId: '',
        placeId: '',
        classId:"",
      },
      downloadDialog: false,
      sizeByMB: 1,
      // 考点名称
      aPlaceInfo:[]
    }
  },
  watch: {
    'requestForm.planId': function(value) {
      this.getPlace(value);
    },
    'requestForm.placeId': function(value) {
      // 考点名称有变化，教室名称也变
      if(value.length>0){
        for(let i=0;i<this.aPlaceInfo.length;i++){
        if(this.aPlaceInfo[i].id == value){
            // 考点名称有变化，教室名称也变
            this.selectList[2].data =   this.aPlaceInfo[i].placeClassList;
            this.requestForm.classId = "";
          }
        }
      }else{
        this.selectList[2].data =   [{id: '', name: '全部'}];
        this.requestForm.classId = "";
      }
    },
  },
  mounted() {
    this.getPlan();
  },
  methods: {
    async getPlan() {
      const { data: planData } = await getSelectPlanFn({"needAudit":"17"});
      this.selectList[0].data = planData;
      this.requestForm.planId = planData[0].id;
    },
    async getPlace(value) {
      // 考点名称 +教室名称下拉框数据获取
      const { data: placeData } = await getCurrentSelectPlace({planId: value});
      if (!placeData) {
        this.selectList[1].data = [];
        this.requestForm.placeId = '';
        // 清空教室的数据
        this.selectList[2].data = [];
        this.requestForm.classId = '';
        return;
      }
      this.aPlaceInfo = placeData;
      this.selectList[1].data = [{id: '', name: '全部'}, ...placeData];
      this.requestForm.placeId = "";
      // 教室的下拉框
      this.selectList[2].data =   [{id: '', name: '全部'}];
      this.requestForm.classId = "";
    },

    // 考试包
    async exportExamPackage() {
      let params = {...this.requestForm}
      params.sizeByMB = 5;
      // 异步模式(1是、0否)
      params.asyncTag = 1;
      const {code, data} = await downloadPreGeneratedAnswerPaperAPI(params);
      if (code == 1) {
        // window.open(data);
        // this.downloadDialog = false;
        this.$message.warning(data);
      }

      return;
      this.downloadDialog = true;
    },

    async exportExamPackageSet() {
      if (this.sizeByMB < 1 || this.sizeByMB > 10) {
        this.$message.warning("数据包分块大小，在 1MB ~ 10MB 之间！");
        return;
      }
      let params = {...this.requestForm}
      params.sizeByMB = this.sizeByMB;
      const {code, data} = await downloadPreGeneratedAnswerPaperAPI(params);
      if (code == 1) {
        window.open(data);
        this.downloadDialog = false;
      }
    },


    // 二维码/序列号
    async export_QAN_Package() {
      let params = { ...this.requestForm }
      const { code, data } = await exportPlaceToPdfAPI(params);
      if (code == 1) {
        window.open(data);
      }
    },
      
    // 授权码
    async exportAuthCode() {
      let params = {...this.requestForm}
      const {code, data} = await exportAuthCodeAPI(params);
      if (code == 1) {
        window.open(data);
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>